module.exports = __webpack_public_path__ + "static/media/Paintballer.48107452.jpg";